import {
  changName,
  createFolder, createNote, deleteItem,
  getDrivesAndNotes, getDrivesHotLoad,
  getFilesToDownloadFolder, getNote, getOneDrive,
  getPortfolio, moveItem, removeFilesToDownloadFolder,
  updateNote, uploadFile, uploadFolder, openFile
} from 'Modules/userList/weekly/store/actions'
import reducer from 'Modules/userList/weekly/store/reducer'
import saga from 'Modules/userList/weekly/store/saga'
import { makeSelectWeekly } from 'Modules/userList/weekly/store/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { useInjectReducer, useInjectSaga } from 'Stores'

export const useWeekly = () => {
  useInjectSaga({ key: 'weekly', saga })
  useInjectReducer({ key: 'weekly', reducer })

  const { idParentMove, listFilesToDownload, listBread, portfolioData, isLoading, topLoad, error, listOneDrive, searchDrive, listFolderMove, notes, openFiles, timezone } = useSelector(
    makeSelectWeekly()
  )

  const dispatch = useDispatch()
  const getListOneDriveAction = (payload) => dispatch(getOneDrive(payload))
  const deleteItemAction = (payload) => dispatch(deleteItem(payload))
  const changeNameAction = (payload) => dispatch(changName(payload))
  const createFolderAction = (payload) => dispatch(createFolder(payload))
  const moveItemAction = (payload) => dispatch(moveItem(payload))
  const uploadFileAction = (payload) => dispatch(uploadFile(payload))
  const getNoteAction = (payload) => dispatch(getNote(payload))
  const updateNoteAction = (payload, conditionGetNotes, callback) => dispatch(updateNote(payload, conditionGetNotes, callback))
  const createNoteAction = (payload, conditionGetNotes, callback) => dispatch(createNote(payload, conditionGetNotes, callback))
  const getDrivesAndNotesAction = (payload, conditionGetNotes) => dispatch(getDrivesAndNotes(payload, conditionGetNotes))
  const getDrivesHotLoadAction = (payload, callback) => dispatch(getDrivesHotLoad(payload, callback))
  const getPortfolioDataAction = (payload) => dispatch(getPortfolio(payload))
  const getFilesToDownloadFolderAction = (payload) => dispatch(getFilesToDownloadFolder(payload))
  const removeFilesToDownloadFolderAction = () => dispatch(removeFilesToDownloadFolder())
  const uploadFolderAction = (payload) => dispatch(uploadFolder(payload))
  const openFileAction = (payload) => dispatch(openFile(payload))

  return {
    idParentMove,
    listFilesToDownload,
    listBread,
    portfolioData,
    isLoading,
    topLoad,
    error,
    listOneDrive,
    searchDrive,
    listFolderMove,
    notes,
    openFiles,
    timezone,
    getListOneDriveAction,
    getPortfolioDataAction,
    deleteItemAction,
    changeNameAction,
    createFolderAction,
    moveItemAction,
    uploadFileAction,
    getNoteAction,
    updateNoteAction,
    createNoteAction,
    getDrivesAndNotesAction,
    getDrivesHotLoadAction,
    getFilesToDownloadFolderAction,
    removeFilesToDownloadFolderAction,
    uploadFolderAction,
    openFileAction
  }
}
